import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import DOMPurify from 'dompurify'


const preprocessMarkdown = (markdown = '') => {
  let text = markdown
    .replace(/\r\n?/g, '\n')      // normalise CRLF/CR to LF first (else \r survives
                                  //   and inflates line breaks)
    .replace(/[ \t]+$/gm, '')     // strip trailing-space hard-break artifacts
    .replace(/\n{3,}/g, '\n\n')   // cap blank-line runs at a single blank line
    .trim()

  // react-markdown 6 has no GFM support, so convert ~~strike~~ to <del>
  // ourselves (rendered as raw HTML via rehype-raw). Then single newlines
  // become <br />.
  text = text.replace(/~~(.*?)~~/g, '<del>$1</del>')
  text = text.replace(/\n/g, '<br />')
  return text
}

const MarkdownViewer = ({ children, className = '' }) => {
  const safeMarkdown = preprocessMarkdown(children)

  const sanitized = DOMPurify.sanitize(safeMarkdown, {
    USE_PROFILES: { html: true },
  })

  const LinkRenderer = ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 underline hover:text-blue-800"
    >
      {children}
    </a>
  )

  return (
    <div className={`prose max-w-none ${className}`}>
      <ReactMarkdown
        rehypePlugins={[rehypeRaw]}
        components={{ a: LinkRenderer }}
      >
        {sanitized}
      </ReactMarkdown>
    </div>
  )
}

export default MarkdownViewer
